import React from 'react';
import Select from "react-select";
import { useFormContext } from 'react-hook-form';
import { formStyles as styles } from './styles';

export default function Step2DeliveryInfo({
    deliveryType,
    setDeliveryType,
    selectedDistrict,
    setSelectedDistrict,
    selectedCommune,
    setSelectedCommune,
    commune,
    district,
    address,
    setAddress,
    getLookupCommune,
    branchId
}) {
    const { register, setValue, formState: { errors } } = useFormContext();
    const isEatAtRestaurantEnabled = branchId === 3;

    return (
        <div>
            <div style={styles.stepHeader}>
                <svg style={styles.stepHeaderIcon} fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                <h3 style={styles.stepHeaderTitle}><span>Hình thức & Địa chỉ</span></h3>
            </div>

            {/* Delivery Method Selection Cards */}
            <div style={{ marginBottom: '30px' }}>
                <label style={{ ...styles.formLabel, fontSize: '16px', display: 'block', marginBottom: '15px' }}>
                    <span>Hình thức nhận hàng</span> <span className='required'>*</span>
                </label>
                <div style={{ display: 'grid', gridTemplateColumns: isEatAtRestaurantEnabled ? '1fr 1fr 1fr' : '1fr 1fr', gap: '15px' }}>
                    {/* Giao nhận Card */}
                    <div style={styles.deliveryCard(deliveryType == 0)}
                        onClick={() => { setDeliveryType(0); setValue("deliveryType", 0); }}>
                        {deliveryType == 0 && (
                            <div style={styles.deliveryCheckmark}>
                                <svg style={{ width: '18px', height: '18px', color: 'white' }} fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                            </div>
                        )}
                        <div style={{ textAlign: 'center' }}>
                            <svg style={{ width: '48px', height: '48px', color: '#95a5a6', marginBottom: '12px' }} fill="currentColor" viewBox="0 0 20 20">
                                <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                                <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" />
                            </svg>
                            <h4 style={{ margin: '0 0 4px 0', color: '#2c3e50', fontSize: '16px', fontWeight: 'bold' }}><span>Giao nhận</span></h4>
                            <p style={{ margin: 0, fontSize: '12px', color: '#7f8c8d' }}><span>Giao tận nơi</span></p>
                        </div>
                    </div>

                    {/* Tự lấy Card */}
                    <div style={styles.deliveryCard(deliveryType == 1)}
                        onClick={() => { setDeliveryType(1); setValue("deliveryType", 1); }}>
                        {deliveryType == 1 && (
                            <div style={styles.deliveryCheckmark}>
                                <svg style={{ width: '18px', height: '18px', color: 'white' }} fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                            </div>
                        )}
                        <div style={{ textAlign: 'center' }}>
                            <svg style={{ width: '48px', height: '48px', color: '#95a5a6', marginBottom: '12px' }} fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z" clipRule="evenodd" />
                            </svg>
                            <h4 style={{ margin: '0 0 4px 0', color: '#2c3e50', fontSize: '16px', fontWeight: 'bold' }}><span>Tự lấy</span></h4>
                            <p style={{ margin: 0, fontSize: '12px', color: '#7f8c8d' }}><span>Đến lấy</span></p>
                        </div>
                    </div>

                    {/* Ăn tại nhà hàng Card */}
                    {isEatAtRestaurantEnabled && (
                        <div style={styles.deliveryCard(deliveryType == 2)}
                            onClick={() => {
                                setDeliveryType(2);
                                setValue("deliveryType", 2);
                            }}>
                            {deliveryType == 2 && (
                                <div style={styles.deliveryCheckmark}>
                                    <svg style={{ width: '18px', height: '18px', color: 'white' }} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                </div>
                            )}
                            <div style={{ textAlign: 'center' }}>
                                <svg style={{ width: '48px', height: '48px', color: '#95a5a6', marginBottom: '12px' }} fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                                    <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2 2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
                                </svg>
                                <h4 style={{ margin: '0 0 4px 0', color: '#2c3e50', fontSize: '16px', fontWeight: 'bold' }}><span>Ăn tại nhà hàng</span></h4>
                                <p style={{ margin: 0, fontSize: '12px', color: '#7f8c8d' }}><span>Ăn tại nhà hàng</span></p>
                            </div>
                        </div>
                    )}
                </div>
                <input type="hidden" {...register("deliveryType")} value={deliveryType} />
            </div>

            {/* Address Section */}
            <div style={{
                padding: '0px',
                backgroundColor: deliveryType == 0 ? 'transparent' : '#f8f9fa',
                borderRadius: '8px',
                border: deliveryType == 0 ? 'none' : '1px dashed #dee2e6',
                marginBottom: '0px'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                    <svg style={{ width: '24px', height: '24px', color: (deliveryType == 1 || deliveryType == 2) ? '#95a5a6' : '#e74c3c', marginRight: '10px' }} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                    <h4 style={{ margin: 0, fontWeight: 'bold', color: (deliveryType == 1 || deliveryType == 2) ? '#95a5a6' : '#2c3e50', fontSize: '16px' }}>
                        <span>{(deliveryType == 1 || deliveryType == 2) ? 'Địa chỉ không cần thiết' : 'Thông tin địa chỉ giao hàng'}</span>
                    </h4>
                </div>

                <div className="row">
                    <div className="form-group col-md-6">
                        <label style={{ ...styles.formLabel, color: (deliveryType == 1 || deliveryType == 2) ? '#95a5a6' : '#34495e' }}>
                            <span>Quận/Huyện</span> {deliveryType == 0 ? <span className='required'>*</span> : ""}
                        </label>
                        <Select isClearable
                            name="districtId"
                            value={selectedDistrict} placeholder="Chọn Quận/Huyện" closeMenuOnSelect={true}
                            onChange={(data) => {
                                setValue("districtId", data ? data.value : null);
                                setSelectedDistrict(data || null);
                                setSelectedCommune(null);
                                setValue("communeId", null);
                                if (data) getLookupCommune(data.value);
                            }}
                            options={district.map(item => { return { label: item.name, value: item.id } })}
                            noOptionsMessage={() => "Không tồn tại"} isDisabled={deliveryType != 0} />
                        {deliveryType == 0 && errors.districtId && errors.districtId.type === "required" && (
                            <span className="error"><span>Trường này là bắt buộc</span></span>
                        )}
                    </div>
                    <div className="form-group col-md-6">
                        <label style={{ ...styles.formLabel, color: (deliveryType == 1 || deliveryType == 2) ? '#95a5a6' : '#34495e' }}>
                            <span>Phường/Xã</span> {deliveryType == 0 ? <span className='required'>*</span> : ""}
                        </label>
                        <Select isDisabled={commune.length == 0 || deliveryType != 0} isClearable
                            name="communeId"
                            value={selectedCommune} placeholder="Chọn Phường/Xã" closeMenuOnSelect={true}
                            onChange={(data) => {
                                setValue("communeId", data ? data.value : null);
                                setSelectedCommune(data || null);
                            }}
                            options={commune.map(item => { return { label: item.name, value: item.id } })}
                            noOptionsMessage={() => "Không tồn tại"} />
                        {deliveryType == 0 && errors.communeId && errors.communeId.type === "required" && (
                            <span className="error"><span>Trường này là bắt buộc</span></span>
                        )}
                    </div>
                </div>

                <div className="row">
                    <div className="form-group col-md-12">
                        <label style={{ ...styles.formLabel, color: (deliveryType == 1 || deliveryType == 2) ? '#95a5a6' : '#34495e' }}>
                            <span>Địa chỉ chi tiết</span> {deliveryType == 0 ? <span className='required'>*</span> : ""}
                        </label>
                        <input className="form-control" type="text" value={address}
                            name="address"
                            placeholder={(deliveryType == 1 || deliveryType == 2) ? "Không cần nhập" : "Số nhà, tên đường, ngõ, ngách..."}
                            readOnly={deliveryType != 0}
                            onChange={(e) => {
                                setAddress(e.target.value);
                                setValue("address", e.target.value);
                            }}
                            style={{ backgroundColor: (deliveryType == 1 || deliveryType == 2) ? '#e9ecef' : '#fff', cursor: (deliveryType == 1 || deliveryType == 2) ? 'not-allowed' : 'text' }} />
                        {deliveryType == 0 && errors.address && errors.address.type === "required" && (
                            <span className="error"><span>Trường này là bắt buộc</span></span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
